<div class="page-head">
  <div>
    <h1 class="page-title">
      Edit
      <span class="pill pill-ready">Draft</span>
    </h1>
    <div class="page-sub">
      Portfolio metadata and the investable universe. Save commits a snapshot.
    </div>
  </div>
  <div class="row">
    <button class="btn btn-ghost btn-sm" type="button">Discard</button>
    <button class="btn btn-primary btn-sm" type="button" (click)="save()">
      <svg viewBox="0 0 24 24">
        <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
        <path d="M17 21v-8H7v8M7 3v5h8" />
      </svg>
      Save portfolio
    </button>
  </div>
</div>

@if (!isLoading) {
  <div class="bento">
    <section class="card exp-col-8">
      <div class="card-head">
        <div class="card-title">Settings</div>
      </div>
      <div class="input-row">
        <div class="field" style="flex: 1 1 240px">
          <div class="field-label">Name</div>
          <input class="input" type="text" [(ngModel)]="name" />
        </div>
        <div class="field" style="flex: 1 1 140px">
          <div class="field-label">Currency</div>
          <input class="input" type="text" [value]="currency" readonly />
        </div>
        <div class="field" style="flex: 1 1 180px">
          <div class="field-label">Benchmark</div>
          <input class="input" type="text" [value]="benchmark" readonly />
        </div>
      </div>
      <div class="input-row" style="margin-top: 10px">
        <div class="field" style="flex: 1 1 140px">
          <div class="field-label">Start date</div>
          <input
            class="input"
            type="text"
            [value]="startDate || '—'"
            readonly
          />
        </div>
        <div class="field" style="flex: 1 1 140px">
          <div class="field-label">End date</div>
          <input class="input" type="text" [value]="endDate || '—'" readonly />
        </div>
        <div class="field" style="flex: 1 1 140px">
          <div class="field-label">Rebalancing</div>
          <input class="input" type="text" [value]="rebalancing" readonly />
        </div>
        <div class="field" style="flex: 1 1 160px">
          <div class="field-label">Weighting</div>
          <input class="input" type="text" [value]="weighting" readonly />
        </div>
      </div>
      <div class="input-row" style="margin-top: 10px">
        <div class="field" style="flex: 0 1 120px">
          <div class="field-label">Risk-free</div>
          <input class="input" type="text" [value]="fmtPct(rfr)" readonly />
        </div>
        <div class="field" style="flex: 0 1 140px">
          <div class="field-label">FX hedging</div>
          <input class="input" type="text" [value]="fxHedging" readonly />
        </div>
        <div class="field" style="flex: 0 1 140px">
          <div class="field-label">Visibility</div>
          <input class="input" type="text" [value]="visibility" readonly />
        </div>
        <div class="field" style="flex: 1 1 240px">
          <div class="field-label">Description</div>
          <input class="input" type="text" [(ngModel)]="description" />
        </div>
      </div>
    </section>
    <section class="card exp-col-4">
      <div class="card-head">
        <div class="card-title">Alti · Portfolio brief</div>
        <span class="alti-chip">Alti</span>
      </div>
      <div class="insights-stack">
        <div class="insight">
          <div class="insight-head">
            <span class="alti-chip">Alti</span
            ><span class="insight-tag">Universe</span>
          </div>
          <p>
            {{ assets.length }} constituents tracked. Largest sleeve:
            <b>{{ assets[0]?.ticker || "—" }}</b> at
            <b>{{ fmtPct(assets[0]?.weight ?? 0) }}</b
            >.
          </p>
        </div>
        <div class="insight">
          <div class="insight-head">
            <span class="alti-chip">Alti</span
            ><span class="insight-tag">Next step</span>
          </div>
          <p>
            Once you save, jump to <b>Optimize</b> to blend your views with
            implied returns.
          </p>
        </div>
      </div>
    </section>
    @if (assets.length) {
      <section class="card exp-col-12">
        <div class="card-head">
          <div class="card-title">
            Selected assets
            <span class="hint"
              >{{ assets.length }} constituents · Total
              {{ fmtPct(totalWeight) }}</span
            >
          </div>
          <button class="btn btn-text btn-sm" type="button">+ Add asset</button>
        </div>
        <div style="overflow-x: auto">
          <table class="exp-table">
            <thead>
              <tr>
                <th class="asset">Asset</th>
                <th class="asset">Sector</th>
                <th class="asset">Country</th>
                <th class="asset">Type</th>
                <th>Weight</th>
              </tr>
            </thead>
            <tbody>
              @for (a of assets; track a) {
                <tr>
                  <td class="asset">
                    <span class="ticker">{{ a.ticker }}</span>
                    <span>{{ a.name }}</span>
                  </td>
                  <td class="asset">{{ a.sector }}</td>
                  <td class="asset">{{ a.country }}</td>
                  <td class="asset">{{ a.type }}</td>
                  <td class="num">{{ fmtPct(a.weight, 2) }}</td>
                </tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <td class="asset" colspan="4">Total</td>
                <td class="num">{{ fmtPct(totalWeight) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
    }
  </div>
}

@if (isLoading) {
  <div class="bento">
    <div class="card exp-col-8">
      <div class="shimmer" style="height: 180px"></div>
    </div>
    <div class="card exp-col-4">
      <div class="shimmer" style="height: 180px"></div>
    </div>
    <div class="card exp-col-12">
      <div class="shimmer" style="height: 380px"></div>
    </div>
  </div>
}

@if (toast) {
  <div class="toast-wrap">
    <div class="toast">
      <span class="dot"></span><span>{{ toast.text }}</span>
    </div>
  </div>
}
